import styled from "styled-components";

export const LayerPop = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.4);
    width: 100%;
    height: 100%;
    z-index: 2000;
    display: inline-block;
    padding: 20px;
    text-align: left;
`

export const BtnLayerCloseBottom = styled.div`
    margin-top: 20px;
    text-align: center;
    display: block;

    button {
        background: none;
        border: 2px solid #418ded;
        color: #418ded;
        font-size: 16px;
        font-weight: bold;
        height: 42px;
        line-height: 38px;
        margin: 0 3px;
        min-width: 125px;
        padding: 0 30px;

        &:hover {
            border-color: #3281ed;
        }
    }
`

export const Popname = styled.div`
    border-bottom: 1px solid #333;
    display: block;
    font-size: 20px;
    line-height: 1;
    padding-bottom: 15px;
    color: black;
`

export const ShareSNSpop = styled.div`
    position: relative;
    padding: 30px 20px;
    border: 1px solid #444;
    background: #fff;
    z-index: 200;
    max-width: 950px;
    width:420px;
    margin: 200px auto;
`
export const ShareSnsList = styled.div`
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;

    button {
        background: none;
        border: 0;
        font-size: 12px;
        padding: 20px 3px 0;
        width: 75px;
    }

    button:hover {
        color: #418ded !important;
    }
`

export const ButtonSNS = styled.button`
    button {
      background: #418ded;
      border: 0;
      color: #fff;
      font-size: 18px;
      height: 50px;
      vertical-align: bottom;
      width: 100px;
    }

    .kakao_story {
        font-size: 11.5px;
    }

    img {
        margin-bottom: 3px;
        width: 100%;
    }
`

export const BtnUrlCopy = styled.button`
    background: #418ded;
    border: 0;
    color: #fff;
    font-size: 18px;
    height: 50px;
    vertical-align: bottom;
    width: 100px;

    &:hover {
        background: #3281ed;
    }
`

export const InputWrapper = styled.div`
    padding: 20px 3px 0;
`

export const CopyUrl = styled.input`
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid #999 !important;
    border-right: 0;
    font-size: 14px;
    height: 50px;
    padding: 14px 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 100px);
`

export const BtnLayerClose = styled.button`
    position: absolute;
    right: 5px;
    top: 5px;
    border: 0;
    background-color: rgba(0,0,0,0);
    vertical-align: middle;
    letter-spacing: 0;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
`
export const CloseIcon = styled.i`
    font-size: 24px;
    color: black;
`
export const WrapperCopyCompelte = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: 14px;
    margin-top: 5px;
`
export const CopyComplete = styled.span`
    font-size: 16px;
    font-weight: bold;
    text-align: left;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/share/newShare/share_layer/share_layer.style.js